import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { MatSort, MatPaginator, MatDialogConfig, MatSnackBar } from '@angular/material';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ManagePackagesDataSource } from '../../../../core/packages/_data-sources/manage-packages.datasource';
import { PackagesHttpService } from '../../../../core/packages';
import { BulkHttpService } from '../../../../core/bulk';
import { SelectOption } from '../../../partials/content/general/searchable-select/searchable-select.component';

@Component({
  selector: 'kt-sw-update',
  templateUrl: './sw-update.component.html',
  styleUrls: ['./sw-update.component.scss']
})
export class SwUpdateComponent implements OnInit, AfterViewInit {

	displayedColumns = ['file_version', 'file_desc', 'file_name', 'uploaded_at', 'actions'];

	dataSource: ManagePackagesDataSource;

	typeSelected: string | number | null = null;
	modeSelected: string | number | null = null;

	typeOptions: SelectOption[] = [
		{ value: 'ui', label: 'UI' },
		{ value: 'menu', label: 'MENU' },
		{ value: 'aux', label: 'VMC' }
	];
	modeOptions: SelectOption[] = [
		{ value: 'engg', label: 'Engineering Review' },
		{ value: 'curr', label: 'Current' },
		{ value: 'arch', label: 'Archived' }
	];

	@Input() mList: any[];

	@Input() macType: string;


	qParams = {};

	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

	@ViewChild(MatSort, {static: false}) sort: MatSort;

	types = [
		{text: 'UI', value: 'ui'},
		{text: 'MENU', value: 'menu'},
		{text: 'VMC', value: 'aux'}
	];

	typesA = [
		{text: 'UI', value: 'ui'},
		{text: 'MENU', value: 'menu'},
		{text: 'VMC', value: 'aux'}
	];

	modes = [
		{text: 'Engineering Review', value: 'engg'},
		{text: 'Current', value: 'curr'},
		{text: 'Archived', value: 'arch'}
	];


  constructor(private pkgHttp: PackagesHttpService, private http: BulkHttpService, private _snackBar: MatSnackBar) { }

  ngOnInit() {
	console.log('onInit');

	this.dataSource = new ManagePackagesDataSource(this.pkgHttp);
	if(!this.macType){
		this.macType = '';
	}
	this.qParams = {
		  noPerPg: this.paginator.pageSize || 5,
		  pgNo: this.paginator.pageIndex || 0,
		  sortKey: 'uploaded_at',
		  sortVal: 'desc',
		  optFilterKey: 'file_type',
		  optFilterVal: '',
		  txtFilterKey: 'file_mode',
		  txtFilterVal: ''
	  };
  }

  ngAfterViewInit() {
	this.dataSource.counter$
	.pipe(
		tap((count) => {
		this.paginator.length = count;
		})
	)
	.subscribe();

	this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

	merge(this.paginator.page, this.sort.sortChange).pipe(
		tap(() => {
			this.loadPackageListPage();
		})
	)
	.subscribe();
  }

  typeChanged(val: string | number | null) {
	this.typeSelected = val;
	if (val && this.modeSelected) {
		this.loadPackageListPage();
	}
	console.log(this.mList);

  }

  modeChanged(val: string | number | null) {
	this.modeSelected = val;
	if (val && this.typeSelected) {
		this.loadPackageListPage();
	}
  }

  loadPackageListPage() {
	const typeValue = this.typeSelected || '';
	const modeValue = this.modeSelected || '';

	const params = {
		noPerPg: this.paginator.pageSize || 5,
		pgNo: this.paginator.pageIndex || 0,
		sortKey: this.sort.active,
		sortVal: this.sort.direction,
		macType: this.macType,
		optFilterKey: 'file_type',
		optFilterVal: typeValue,
		txtFilterKey: 'file_mode',
		txtFilterVal: modeValue
	};
	// // console.log(params);
	this.dataSource.loadPackageList(params);
  }

  assign(file: any) {
	console.log(this.mList);
	file.machines = this.mList;
	this.http.assignBulkUpdates(file)
	.subscribe(result => {
		this.showSnackBar('Assigned successfully', 3000);
	}, error => {
		this.showSnackBar('Unable to assign, Something went wrong', 0);
	});
  }

  showSnackBar(message: string, duration: number) {
	let snackRef = this._snackBar.open(message, 'close');
	if (duration > 0) {
		setTimeout(() => {
			this._snackBar.dismiss();
		}, duration);
	}

	snackRef.onAction().subscribe(() => {
		this._snackBar.dismiss();
	});
}

}
